import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_DOCUMENT_TYPE,
  CLEAR_DOCUMENT_TYPES,
  FLAG_GETTING_DOCUMENT_TYPE,
  FLAG_GETTING_DOCUMENT_TYPES,
  GET_DOCUMENT_TYPE,
  GET_DOCUMENT_TYPES,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_DOCUMENT_TYPES:
      return state.setIn(['all', 'loading'], payload);
    case GET_DOCUMENT_TYPES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_DOCUMENT_TYPES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_GETTING_DOCUMENT_TYPE:
      // raising flag
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_DOCUMENT_TYPE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_DOCUMENT_TYPE:
      return state.setIn(['current', 'content'], INITIAL_STATE.getIn(['current', 'content']));
    default:
      return state;
  }
};
